module.exports = __webpack_public_path__ + "img/feature-capture.3cf0ab5e.png";